<template lang="html">
    <div class="quanyiContainer">
    	<div class="title">专属权益</div>
		<div class="sub-title">君子之道，洪泽天下；君子有志，弘毅宽厚。君弘财富俱乐部是由国泰君安倾心打造的证券行业第一俱乐部品牌，为高端财富人群一揽子专属全面的个性化服务及增值服务。</div>
		<div class="quanyiBox">
			<div class="box right">
				<div class="listImg">
					<img src="../../assets/img/membership_vip.png">
				</div>
				<div class="listText">
					<div class="listTitle">尊贵标识</div>
					<div class="listEngTitle">MEMBERSHIP LOGO</div>
					<div class="listContent">
						专属会员标识，彰显个性光芒
					</div>
				</div>
			</div>
			<div class="box left">
				<div class="listImg">
					<img src="../../assets/img/membership_service.png">
				</div>
				<div class="listText">
					<div class="listTitle">专属服务</div>
					<div class="listEngTitle">VIP SERVICE</div>
					<div class="listContent">
						精选普惠投资、共享人生、流金溢彩、品质精钻、至臻尊享五大服务系列，打造会员专属服务产品。
					</div>
				</div>
			</div>
			<div class="box right">
				<div class="listImg">
					<img src="../../assets/img/membership_activity.png">
				</div>
				<div class="listText">
					<div class="listTitle">会员活动</div>
					<div class="listEngTitle">MEMBER ACTIVITIES</div>
					<div class="listContent">
						涵盖“境外投资、财富传承、子女教育、公益活动”多个系列活动。为您创造良好的互动交流平台，打造优质社交圈。
					</div>
				</div>
			</div>
			<div class="box left">
				<div class="listImg">
					<img src="../../assets/img/membership_jifen.png">
				</div>
				<div class="listText">
					<div class="listTitle">君弘积分</div>
					<div class="listEngTitle">JUNONG </div>
					<div class="listContent">
						当您是君弘会员银卡及以上级别时，您将获得君弘积分专属会员特权。您的君弘积分可用于君弘积分商城进行礼品兑换。
					</div>
				</div>
			</div>
			<div class="box right">
				<div class="listImg">
					<img src="../../assets/img/membership_rights.png">
				</div>
				<div class="listText">
					<div class="listTitle">业务优先享受权</div>
					<div class="listEngTitle">BUSINESS PRIORITY</div>
					<div class="listContent">
						您可以在各营业网点享受业务办理的优先通道。
					</div>
				</div>
			</div>
			<div class="box left">
				<div class="listImg">
					<img src="../../assets/img/membership_plan.png">
				</div>
				<div class="listText">
					<div class="listTitle">理财规划</div>
					<div class="listEngTitle">FINACIALING PLAN </div>
					<div class="listContent">
						您可以体验专属投资顾问为您提供的全面资产检视服务及线上智能理财规划，助您实现财富人生。
					</div>
				</div>
			</div>
			<div class="box right">
				<div class="listImg">
					<img src="../../assets/img/membership_global.png">
				</div>
				<div class="listText">
					<div class="listTitle">全球市场观察</div>
					<div class="listEngTitle">GLOBAL MARKETING</div>
					<div class="listContent">
						OBSERVATION<br/>
						美股、港股讯息全球观察。
					</div>
				</div>
			</div>
			<div class="box left">
				<div class="listImg">
					<img src="../../assets/img/membership_gift.png">
				</div>
				<div class="listText">
					<div class="listTitle">专享礼遇</div>
					<div class="listEngTitle">SPECEIAL GIFTS</div>
					<div class="listContent">
						您可以享受专属产品、灵犀周边等定制礼物。
					</div>
				</div>
			</div>
			<div class="box right">
				<div class="listImg">
					<img src="../../assets/img/membership_more.png">
				</div>
				<div class="listText">
					<div class="listTitle">更多权益敬请期待</div>
					<div class="listEngTitle">COMING SOON……</div>
					<div class="listContent">
						商旅出行、品质生活、健康医疗、运动休闲…更多增值权益敬请期待。
					</div>
				</div>
			</div>
		</div>
    </div>
</template>
<script>
	export default {
	  	name: 'quanyiContainer',
	}
</script>
<style lang="less" scoped>
	.quanyiContainer{
		padding:0px 40px;
		width:100%;
		.title{
			width:100%;
			height:40px;
			font-size:32px;
			color:#ad8f5a;
			letter-spacing:0;
			line-height:40px;
			text-align:left;
			font-weight:bold;
		}
		.sub-title{
			margin-top:20px;
			width:100%;
			font-size:24px;
			color:#999999;
			letter-spacing:0;
			line-height:40px;
			text-align:left;
		}
		.quanyiBox{
			display:inline-block;
			margin-bottom:30px;
			.left{
				float:right;
			}
			.right{
				float:left;
			}
			.box{
				background:#f1f1f1;
				border-radius:0 0 12px 12px;
				width:48%;
				margin-top:20px;
				.listImg{
					width:100%;			
					img{
						width:100%;
					}
				}
				.listText{
					width:100%;
					padding:30px 20px;
					color:#333333;
					text-align:left;
					.listTitle{
						font-size:28px;
						letter-spacing:0;
						line-height:28px;
					}
					.listEngTitle{
						font-size:24px;
						letter-spacing:1.2px;
						line-height:24px;
						margin-top:20px;
					}
					.listContent{
						margin-top:10px;
						font-size:24px;
						letter-spacing:1.2px;
						line-height:46px;
						height:180px;
						text-overflow:ellipsis;
						overflow: hidden;
				    	display: -webkit-box;
		    			-webkit-line-clamp: 4;
		    			-webkit-box-orient: vertical;
		    			word-break:break-all;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/quanyi/quanyiContainer.vue